<template>
  <div>
    <LoadingPage v-if="loadingData"></LoadingPage>
    <ArticleComponent v-if="!loadingData" :article="article"></ArticleComponent>
  </div>
</template>

<script>
import ArticleComponent from '@/components/ArticleComponent.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import APIService from '@/apiservices/APIService.js'
export default {
  props: {
    article_id: {
      type: String,
      required: true
    }
  },
  components: {
    ArticleComponent,
    LoadingPage
  },
  data() {
    return {
      article: null,
      loadingData: false
    }
  },
  created() {
    this.loadingData = true
    APIService.getArticle(this.article_id)
      .then(({ data }) => {
        this.article = data
        this.loadingData = false
      })
      .catch(error => {
        console.log('There was an error in getArticle API call:', error)
      })
  }
}
</script>

<style></style>
